module.exports = __webpack_public_path__ + "img/sv.a354c6b9.svg";